import Phaser from 'phaser';
import { GAME_WIDTH } from '../config/gameConstants';
import { AudioKeys, SceneKeys, TextureKeys } from '../config/keys';
import { AudioManager } from '../managers/AudioManager';

export class MenuScene extends Phaser.Scene {
  private audioManager!: AudioManager;
  private muteButton!: Phaser.GameObjects.Text;

  constructor() {
    super(SceneKeys.Menu);
  }

  create(): void {
    this.audioManager = AudioManager.get(this);
    this.add.image(0, 0, TextureKeys.PaperBackground).setOrigin(0);
    this.addDecor();

    this.add
      .text(GAME_WIDTH / 2, 132, 'Flappy\nStick Bird', {
        fontFamily: '"Trebuchet MS", "Comic Sans MS", sans-serif',
        fontSize: '56px',
        lineSpacing: -8,
        color: '#28221a',
        align: 'center',
        stroke: '#f7f0dc',
        strokeThickness: 8,
      })
      .setOrigin(0.5);

    const bird = this.add.sprite(GAME_WIDTH / 2, 312, TextureKeys.BirdFrame1).setScale(1.75);
    bird.play('bird-flap');
    this.tweens.add({
      targets: bird,
      y: bird.y - 18,
      angle: 5,
      duration: 620,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.inOut',
    });

    this.add
      .text(GAME_WIDTH / 2, 438, 'tap or press space', {
        fontFamily: '"Trebuchet MS", "Comic Sans MS", sans-serif',
        fontSize: '25px',
        color: '#3f3324',
      })
      .setOrigin(0.5);

    const startButton = this.add
      .text(GAME_WIDTH / 2, 536, 'START', {
        fontFamily: '"Trebuchet MS", "Comic Sans MS", sans-serif',
        fontSize: '34px',
        color: '#28221a',
        backgroundColor: '#f8d36d',
        padding: { x: 34, y: 15 },
      })
      .setOrigin(0.5)
      .setInteractive({ useHandCursor: true });

    startButton.on(Phaser.Input.Events.POINTER_DOWN, () => this.startGame());

    this.muteButton = this.add
      .text(GAME_WIDTH - 28, 28, this.audioManager.isMuted() ? 'sound off' : 'sound on', {
        fontFamily: '"Trebuchet MS", "Comic Sans MS", sans-serif',
        fontSize: '16px',
        color: '#28221a',
      })
      .setOrigin(1, 0)
      .setInteractive({ useHandCursor: true });
    this.muteButton.on(Phaser.Input.Events.POINTER_DOWN, () => {
      const muted = this.audioManager.toggleMuted();
      this.muteButton.setText(muted ? 'sound off' : 'sound on');
    });

    this.input.keyboard?.once('keydown-SPACE', () => this.startGame());
    this.input.keyboard?.once('keydown-ENTER', () => this.startGame());
    this.input.once(Phaser.Input.Events.POINTER_DOWN, (pointer: Phaser.Input.Pointer) => {
      if (startButton.getBounds().contains(pointer.x, pointer.y) || this.muteButton.getBounds().contains(pointer.x, pointer.y)) {
        return;
      }
      this.startGame();
    });
  }

  private startGame(): void {
    this.audioManager.play(AudioKeys.MenuSelect);
    this.scene.start(SceneKeys.Game);
  }

  private addDecor(): void {
    this.add.image(84, 236, TextureKeys.Cloud).setAlpha(0.56);
    this.add.image(304, 230, TextureKeys.Cloud).setScale(0.72).setAlpha(0.48);

    const graphics = this.add.graphics();
    graphics.lineStyle(3, 0x28221a, 0.55);
    graphics.beginPath();
    graphics.moveTo(74, 662);
    graphics.lineTo(116, 638);
    graphics.lineTo(158, 664);
    graphics.strokePath();
    graphics.strokeCircle(286, 652, 24);
    graphics.lineBetween(272, 638, 300, 666);
    graphics.lineBetween(300, 638, 272, 666);
  }
}
